import { OPTION_TYPE } from "Common/dictionaries/optionType";
export const optionTypeDataTypeMap = {
    [OPTION_TYPE.BOOL]: "boolean",
    [OPTION_TYPE.DATETIME]: "date",
    [OPTION_TYPE.DICTIONARY]: "string",
    [OPTION_TYPE.INT]: "number",
    [OPTION_TYPE.STRING]: "string",
    [OPTION_TYPE.TAGS]: "object",
    [OPTION_TYPE.IMAGE]: "object"
};
export const optionTypeAllowHeaderFilteringMap = {
    [OPTION_TYPE.BOOL]: true,
    [OPTION_TYPE.DATETIME]: false,
    [OPTION_TYPE.DICTIONARY]: true,
    [OPTION_TYPE.INT]: false,
    [OPTION_TYPE.STRING]: true,
    [OPTION_TYPE.TAGS]: true,
    [OPTION_TYPE.IMAGE]: false
};
